import React, { useEffect, useState }   from 'react';
import { Grid } from "@mui/material"
import { useRecoilCallback, useRecoilValue, useSetRecoilState } from "recoil"
import AutocompleteSkeleton from "src/shared/components/skeletons/AutocompleteSkeleton"
import useCatchErrorApi from "src/shared/hooks/useCatchErrorApi"
import AutocompleteSucursales from "./components/autocompletes/AutocompleteSucursales"
import AutocompleteBranch from "./components/autocompletes/AutocompleteBranch"
import AutocompleteTipoExamen from "./components/autocompletes/AutocompleteTipoExamen"
import AutocompleteExamen from "./components/autocompletes/AutocompleteExamen"
import { tipoExamenState, tipoExamenesFetchState, examenState, examenesFetchState, ExamenByTipoExamenState, sucursalesFetchState, sucursalesState, clinicasState, clinicasFetchState } from "./components/autocompletes/state/atoms"
import { filterSearchSelectedState, isChangeFormSearchState } from "./state/atoms"

const FormSearchImagenologia = ({ size = "small", md = 12, xs = 12, styles = {}, buttonSearch = null }) => {
    const { catchErrorApi } = useCatchErrorApi();
    const setIsChangeFormSearch = useSetRecoilState(isChangeFormSearchState);
    const filterSearchSelected = useRecoilValue(filterSearchSelectedState);
    const setSucursales = useSetRecoilState(sucursalesState);
    const setClinicas = useSetRecoilState(clinicasState);
    //const setProfessionals = useSetRecoilState(professionalsState);
    //const setSpecialities = useSetRecoilState(specialitiesState);
    const setTipoExamen = useSetRecoilState(tipoExamenState);
    const setExamen = useSetRecoilState(examenState);
    const [loading, setLoading] = useState(false);

    const loadData = useRecoilCallback(({ snapshot }) => async () => {
        const release = snapshot.retain();
        setLoading(true)
        try {
            console.log("CLICK TAB IMG")
            const clinicasFetch = snapshot.getPromise(clinicasFetchState); 
            // const sucursalesFetch = snapshot.getPromise(sucursalesFetchState);             
            // const tipoExamenesFetch = snapshot.getPromise(tipoExamenesFetchState);
            // const examenesFetch = snapshot.getPromise(ExamenByTipoExamenState(filterSearchSelected.tipoExamenSelected.value));
            //let tipo_examen = filterSearchSelected.tipoExamenSelected.value
            console.log("TIPO EXAMEN SELECTED => ", filterSearchSelected.tipoExamenSelected.value );
            const responses = await Promise.all([
                clinicasFetch,        
                // examenesFetch,
            ]);
            setClinicas(responses[0])
            // setSucursales(responses[1])
            // setTipoExamen(responses[2])
            //setExamen(responses[3]) 
            //setTipoExamen(responses[2])
            //console.log(responses[2]);
            //setCovenants(responses[2])

        } catch (error) {
            console.log(error)
            catchErrorApi(error)
        } finally {
            setLoading(false)
            release()
        }
    }, []);

    useEffect(() => {
        loadData()

        return () => {
            loadData()
        }
    }, [loadData])

    useEffect(() => {
        return () => {
            setIsChangeFormSearch(false);
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    //const myFunction = async (obj) => {
    const myFunction = useRecoilCallback(({ snapshot }) => async (obj) => {
        const examenesFetch = snapshot.getPromise(ExamenByTipoExamenState(obj.ptD_RUT));
        const responses = await Promise.all([
            examenesFetch,
        ]);
        console.log(responses[0])
        setExamen(responses[0]) 

    }, []);

    return (
        <Grid container sx={{background: "transparent"}} spacing={"12px"}>

            <Grid item md={md} sx={{background: "transparent"}} xs={xs} bottom>
                {loading ? <AutocompleteSkeleton /> : <AutocompleteBranch size={size} styles={{ ...styles }} />}
            </Grid>            
            <Grid item md={md} xs={12} sx={{background: "transparent"}} bottom>
                {loading ? <AutocompleteSkeleton /> : <AutocompleteSucursales size={size} styles={{ ...styles }} />}
            </Grid>

            <Grid item md={md} xs={12} sx={{background: "transparent"}} bottom>
                {loading ? <AutocompleteSkeleton /> : <AutocompleteTipoExamen size={size} styles={{ ...styles }} myEvent={myFunction} />}
            </Grid>

            <Grid item md={md} xs={12} sx={{background: "transparent"}}>
                {loading ? <AutocompleteSkeleton /> : <AutocompleteExamen size={size} styles={{ ...styles }} />}
            </Grid>

            {
                buttonSearch && (
                    <Grid display={"flex"} justifyContent="center" alignItems={"center"} sx={{background: "transparent"}} item md={md} xs={12}>
                        {buttonSearch}
                    </Grid>
                )
            }
        </Grid>
    )
}

export default FormSearchImagenologia
